import { TimeUnitApi } from 'api-typings/common/common';
import { MembershipTrial } from './membership-trials.model';

export function generateMembershipTrialsObjects(): readonly MembershipTrial[] {
  return [
    {
      id: 1,
      packageId: 5,
      duration: {
        id: 3,
        type: TimeUnitApi.MONTH,
        cycle: 1,
      },
      eligible: true,
      trialPackageId: 5,
      trialDuration: {
        id: 3,
        type: TimeUnitApi.MONTH,
        cycle: 1,
      },
      timeValidStart: Date.now(),
      isDefault: true,
      package: {
        id: 5,
        internalName: 'plan25',
        displayName: 'plus',
        enabled: true,
        categoryId: 1,
        order: 4000,
      },
      trialPackage: {
        id: 5,
        internalName: 'plan25',
        displayName: 'plus',
        enabled: true,
        categoryId: 1,
        order: 4000,
      },
    },
    {
      id: 3,
      packageId: 5,
      duration: {
        id: 9,
        type: TimeUnitApi.YEAR,
        cycle: 1,
      },
      eligible: true,
      trialPackageId: 5,
      trialDuration: {
        id: 3,
        type: TimeUnitApi.MONTH,
        cycle: 1,
      },
      timeValidStart: Date.now(),
      isDefault: true,
      package: {
        id: 5,
        internalName: 'plan25',
        displayName: 'plus',
        enabled: true,
        categoryId: 1,
        order: 4000,
      },
      trialPackage: {
        id: 5,
        internalName: 'plan25',
        displayName: 'plus',
        enabled: true,
        categoryId: 1,
        order: 4000,
      },
    },
  ];
}
